import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

import { Error } from './error.types'
import { MedicalRecordPayload } from 'models/MedicalRecord'

export const updateForm = (formUuid: string, payload: MedicalRecordPayload) => {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_UPDATE_FORM(formUuid)

  return new Promise((resolve, reject) => {
    axios
      .put(endpoint, payload)
      .then((response) => resolve(response))
      .catch((error: Error) => {
        reject(error)
      })
  })
}
